import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SettingsContext } from './SettingsContext';
import { useLang } from './LangContext';
import { getT } from './translations';

const Header = () => {
  const location = useLocation();
  const { setShowSettings } = useContext(SettingsContext);
  const { lang } = useLang();
  const t = getT(lang);
  const isTimerPage = location.pathname === "/";

  return (
    <header
      style={{
        width: '100%',
        backgroundColor: 'var(--body-bg)', // same as the body background
        borderBottom: '1px solid var(--heading-color)', // uses heading color from theme
        display: 'flex',
        alignItems: 'center',
        padding: '0.5rem 1rem',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        transition: 'background-color 0.5s ease, color 0.5s ease',
      }}
    >
      <Link
        to="/"
        style={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
        }}
      >
        <img
          src="/pomodoro_logo.png"
          alt="Pomodoro Logo"
          style={{ height: '40px', marginRight: '0.5rem' }}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <span
          style={{
            fontFamily: '"Courier Std", monospace',
            fontSize: '1.5rem',
            color: 'var(--heading-color)',
          }}
        >
          Pomodoro Flow
        </span>
      </Link>
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        {isTimerPage && (
          <button
            id="open-settings"
            onClick={() => setShowSettings(true)}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
              padding: '0',
              position: 'static',
              height: '40px',
              lineHeight: 1,
            }}
          >
            <span style={{ fontSize: '1.92rem', color: 'var(--heading-color)', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1 }}>⚙</span>
            <span
              style={{
                fontSize: '1rem',
                fontFamily: 'inherit',
                color: 'var(--heading-color)',
                display: 'flex',
                alignItems: 'center',
                lineHeight: 1,
                transform: 'translateY(2px)',
              }}
            >
              {t.headerSettings}
            </span>
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;